<div class="container my-5">
    <h2 class="text-center mb-4">
        {{ 'cargaEmpresas.listEmpresas' | translate }}
    </h2>
    <div class="row">
        <div class="col-md-4 mb-4" *ngFor="let empresa of empresas">
            <div class="card shadow-sm">
                <div class="card-body">
                    <h4 class="card-title">
                        {{ 'cargaEmpresas.agenteVigilado' | translate }}
                    </h4>
                    <p class="card-text">
                        {{ 'cargaEmpresas.razonSocial' | translate }}:
                        {{ empresa.razonSocial }}
                    </p>
                    <p class="card-text">
                        {{ 'cargaEmpresas.nit' | translate }}: {{ empresa.nit }}
                    </p>
                    <a
                        (click)="ingresar(empresa.id, empresa.nit)"
                        class="btn btn-primary btn_color">
                        {{ 'cargaEmpresas.ingresar' | translate }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
